import { useState } from 'react';

interface FAQItem {
  q: string;
  a: string;
}

const FAQ_ITEMS: FAQItem[] = [
  {
    q: 'Сколько времени занимает изготовление?',
    a: 'Стандартный навес или ворота изготавливаем за 5–10 рабочих дней после замера и&nbsp;подписания договора. Сложные конструкции (беседки, мангальные зоны) — до&nbsp;14&nbsp;дней. Монтаж на&nbsp;объекте занимает 1–3&nbsp;дня в&nbsp;зависимости от&nbsp;объёма.',
  },
  {
    q: 'Нужен ли фундамент под конструкцию?',
    a: 'Да, для навесов, беседок и ворот требуется бетонирование опорных столбов. Мы выполняем эту работу сами — бурим лунки, устанавливаем столбы и&nbsp;заливаем бетоном. Глубина заложения зависит от&nbsp;типа грунта, обычно 80–120&nbsp;см.',
  },
  {
    q: 'Можно ли сделать по фотографии из интернета?',
    a: 'Да, конечно. Присылайте фото или ссылку — мы оценим сложность и&nbsp;адаптируем конструкцию под&nbsp;ваши размеры и&nbsp;участок. Также можем предложить похожие варианты из&nbsp;нашего портфолио.',
  },
  {
    q: 'Как проходит замер на участке?',
    a: 'Приезжаем в&nbsp;удобное для вас время. Делаем точные замеры рулеткой и&nbsp;нивелиром, оцениваем тип грунта, уклон участка, расположение коммуникаций. Обсуждаем ваши пожелания и&nbsp;сразу даём рекомендации. Замер бесплатный при&nbsp;последующем заказе.',
  },
  {
    q: 'Какая гарантия на ваши изделия?',
    a: 'Даём гарантию 2&nbsp;года на&nbsp;каркас и&nbsp;сварные швы. При&nbsp;соблюдении условий эксплуатации конструкции служат 20&nbsp;лет и&nbsp;более. Антикоррозийная обработка и&nbsp;покраска защищают металл от&nbsp;ржавчины.',
  },
  {
    q: 'Как происходит оплата?',
    a: 'Работаем по договору. Предоплата 50% перед началом изготовления, остальные 50% — после завершения монтажа и&nbsp;подписания акта приёмки. Принимаем наличные и&nbsp;перевод на&nbsp;карту.',
  },
];

export default function FAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  const toggle = (idx: number) => {
    setOpenIdx(openIdx === idx ? null : idx);
  };

  return (
    <section className="py-16 md:py-20 bg-background-50" id="faq">
      <div className="mx-auto px-4 md:px-6" style={{ maxWidth: '900px' }}>
        <div className="text-center mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Ответы на вопросы
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Собрали самые частые вопросы от&nbsp;наших клиентов
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {FAQ_ITEMS.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 border border-background-200/60 rounded-lg overflow-hidden"
            >
              <button
                onClick={() => toggle(idx)}
                className="w-full flex items-center justify-between px-5 md:px-6 py-4 text-left cursor-pointer hover:bg-background-200/30 transition-colors duration-200"
              >
                <span className="font-heading text-base md:text-lg font-semibold text-foreground-950 pr-4">
                  {item.q}
                </span>
                <span
                  className={`w-6 h-6 flex items-center justify-center shrink-0 text-foreground-500 transition-transform duration-300 ${
                    openIdx === idx ? 'rotate-45' : ''
                  }`}
                >
                  <i className="ri-add-line text-xl"></i>
                </span>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p
                  className="px-5 md:px-6 pb-5 text-sm md:text-base text-foreground-600 leading-relaxed"
                  dangerouslySetInnerHTML={{ __html: item.a }}
                ></p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}